import { deleteApi, patchApi, postApi, putApi } from "../apiCall";

const rateLimiter = (() => {
  const COOLDOWN_TIME_MS = 5000; // 5 seconds

  // Stores the last successful execution time for each function
  const lastExecuted = {
    handleRaFinalizeT_C: 0,
  };

  /**
   * Checks if the function is within the cooldown period and updates the timestamp.
   * @param {string} funcName - The name of the function being called.
   * @returns {boolean} - True if the call should be ignored (rate-limited), false otherwise.
   */
  const checkAndSetTimer = (funcName) => {
    const now = Date.now();
    const timeElapsed = now - lastExecuted[funcName];

    if (timeElapsed < COOLDOWN_TIME_MS) {
      return true; // Ignore the call
    }

    // Update the timestamp for the current successful execution
    lastExecuted[funcName] = now;

    return false; // Proceed with the call
  };

  return { checkAndSetTimer };
})();

export const createAuctionTender = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/create`;
  return postApi(url, payload);
};

export const updateAuctionTender = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/update/${id}`;
  return putApi(url, payload);
};

export const activateTender = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/${id}/activateTender`;
  return putApi(url, payload);
};
export const terminateTender = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/${id}/terminate`;
  return patchApi(url, payload);
};

export const createBid = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/connect/createBid`;
  return postApi(url, payload);
};

export const updateBid = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/connect/update`;
  return putApi(url, payload);
};

export const updateQuantityRequest = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/connect/sendAmountChangeRequest`;
  return postApi(url, payload);
};

export const approveQuantityRequest = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/connect/respondToAmountChangeRequest`;
  return postApi(url, payload);
};
export const updateWinnerBidStatus = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/connect/update-winner-status`;
  return putApi(url, payload);
};

export const handleInviteParticipants = (id, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/${id}/inviteParticipants`;
  return postApi(url, payload);
};

export const handleRaFinalizeT_C = (payload) => {
  const funcName = "handleRaFinalizeT_C";
  if (rateLimiter.checkAndSetTimer(funcName)) {
    // Check the timestamp
    return Promise.resolve({
      success: false,
      message: `Call to ${funcName} rate-limited.`,
    });
  }
  let url = `${process.env.REACT_APP_API_URL}/bsra/connect/finalizeWinnerBids`;
  return postApi(url, payload);
};

export const handleRemoveUser_api = ({ tenderId, genId }) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/removeParticipant?tenderId=${tenderId}&participantId=${genId}`;
  return deleteApi(url);
};
